import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@mui/material';

/** Decision 4.4 — dismiss with a mandatory reason. */
const DismissDialog = ({ candidate, open, submitting, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Dismiss candidate</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {candidate?.fullName} stays in the list (filtered out by default) until the reason or contract changes in the source feed.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label="Reason"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          disabled={submitting}
          placeholder="e.g. handled through the placement pipeline already"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
        <Button variant="contained" disabled={submitting || !reason.trim()} onClick={() => onSubmit(reason.trim()).then(() => setReason(''))}>
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DismissDialog;
